import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { PAGES } from './utils/varGlobal.js';

// Componentes
import Main from './components/pages/main.js';
import ErrorPage from './components/pages/error/pageError.js';
import PageAboutUs from './components/pages/aboutUs/pageAboutUs.js';
import PageContact from './components/pages/contact/pageContact.js';
import PageWork from './components/pages/work/pageWork.js';

function Router() {
	return (
		<BrowserRouter>
			<Routes>
				<Route 
					path	= {PAGES.MAIN}
					element	= {<Main/>}/>
				
				<Route
					path	= {PAGES.ABOUT_US}
					element	= {<PageAboutUs/>}/>

				<Route
					path	= {PAGES.CONTACT}
					element = {<PageContact/>}/>

				<Route
					path	= {PAGES.WORK}
					element = {<PageWork/>}/>

				<Route
					path	= '*'
					element = {<ErrorPage/>}/>
				
			</Routes>
		</BrowserRouter>
	);
}

export default Router;
